import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgEvolution = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 128 40"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="#000"
        d="M23.508 11.325h12.924v2.93H26.87v4.275h6.37v2.929h-6.37v4.776h9.858v2.93h-13.22z"
      />
      <path
        fill="#000"
        d="M36.433 16.486h3.44l3.008 8.836 2.791-8.836h3.332l-4.62 12.679h-3.086zM49.112 22.855c0-3.873 2.683-6.605 6.526-6.605 3.814 0 6.507 2.742 6.507 6.605 0 3.813-2.742 6.555-6.586 6.555-3.813 0-6.447-2.693-6.447-6.555m9.652.078v-.108c0-2.418-1.18-3.872-3.116-3.872-1.966 0-3.145 1.454-3.145 3.872v.108c0 2.369 1.15 3.765 3.086 3.765 1.966 0 3.175-1.406 3.175-3.765M64.297 11.08h3.361v18.085h-3.361zM70.205 24.083v-7.597h3.332v7.41c0 1.69.806 2.684 2.31 2.684 1.75 0 2.477-1.475 2.477-3.657v-6.437h3.332v12.679h-3.332v-1.799c-.668 1.317-1.828 2.044-3.47 2.044-2.87 0-4.649-2.044-4.649-5.327M85.33 25.803v-6.634h-1.799v-2.684h1.8v-2.398l3.252-1.828v4.216h2.497v2.684h-2.526v6.31c0 .619.295.884.914.914h1.474v2.772h-2.575c-2.447-.128-2.978-1.249-3.037-3.352M93.233 11.375h3.47v3.253h-3.47zm.049 5.11h3.361v12.68h-3.361zM98.796 22.855c0-3.873 2.683-6.605 6.526-6.605 3.814 0 6.507 2.742 6.507 6.605 0 3.813-2.742 6.555-6.586 6.555-3.813 0-6.447-2.693-6.447-6.555m9.642.078v-.108c0-2.418-1.18-3.872-3.116-3.872-1.966 0-3.145 1.454-3.145 3.872v.108c0 2.369 1.15 3.765 3.086 3.765 1.966 0 3.175-1.406 3.175-3.765M113.952 16.485h3.332v2.064c.668-1.474 1.907-2.339 3.705-2.339 2.772 0 4.404 1.858 4.404 5.347v7.607h-3.332v-7.41c0-1.77-.669-2.684-2.231-2.684-1.583 0-2.556 1.288-2.556 3.657v6.447h-3.332zM15.666 12.969c-3.037-4-8.551-5.13-13.131-2.683 1.789 4.02 3.125 8.747 11.942 9.022q1.548.047 3.42-.098c-.177-2.526-1.002-4.62-2.231-6.241M14.044 21.196c-5.307.265-7.794 2.192-9.347 4.58-.914 1.406-1.504 2.959-2.162 4.423 6.428 3.43 14.733-.187 15.362-8.934a31 31 0 0 0-3.853-.07"
      />
    </svg>
  );
};
export default SvgEvolution;
